import { NavMenu } from '@scope/scope-one-ui/core';
import styled from 'styled-components';

export const Tabs = styled(NavMenu)`
  text-transform: uppercase;
`;
